var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner"},[_c('div',{staticClass:"topcontent"},[_c('HeaderBottom',{attrs:{"img":require('@/assets/img/bg6.jpg'),"message":'Partner'}}),_c('NavMenu')],1),_c('div',{staticClass:"centralcontent"},[_c('div',{staticClass:"liens"},[_vm._v(" Startseite | "),_c('router-link',{attrs:{"to":"/partner"}},[_vm._v("Partner")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }